import axios from "axios";
import { apiURI } from "../ENVs";

// The bulk-upload Excel template is stored as a blob in the `qualityreports` container, under a
// virtual `templates/` folder (Azure folders are just `/`-prefixed blob names). It's served
// through the authenticated backend proxy (GET /form/file). Upload the template to this exact
// blob path — the browser never talks to storage directly.
const BULK_UPLOAD_TEMPLATE_BLOB = "templates/bulk-upload-template.xlsx";
// Name the user sees when the file is saved. A blob: URL has no filename, so we must set it
// explicitly via the download attribute — otherwise the browser shows the object-URL id.
const BULK_UPLOAD_TEMPLATE_FILENAME = "bulk-upload-template.xlsx";

export async function downloadBulkUploadTemplate() {
  try {
    // Fetch with the JWT (default axios header); the backend streams the file via Managed
    // Identity, keeping the blob's native content type.
    const { data } = await axios.get(`${apiURI}/form/file`, {
      params: { path: BULK_UPLOAD_TEMPLATE_BLOB },
      responseType: "blob",
    });

    // Trigger a download with the proper filename.
    const objectUrl = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = BULK_UPLOAD_TEMPLATE_FILENAME;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Revoke after a tick so the browser has started reading the blob for the download
    // (revoking synchronously can cancel the download in some browsers).
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  } catch (error) {
    console.log({ error });
  }
}
